if(!customElements.get("collection-filters")) {
  customElements.define("collection-filters", class CollectionFilters extends HTMLElement {
    constructor() {
      super();

      this.categoryLabels = Array.from(this.querySelectorAll(".collection-filters__categories .collection-filters__category"));
      this.valuesContainer = this.querySelector(".collection-filters__inputs-container");
      this.categoryValues = Array.from(this.querySelectorAll(".collection-filters__inputs-container .collection-filters__inputs"));
      this.categoryValueLabels = Array.from(this.querySelectorAll(".collection-filters__value .value-wrapper"));

      this.valuesList = this.categoryValueLabels.map((cat) => cat.querySelector("input[type='radio']"));

      // sortby dropdown
      this.sortDropdown = this.querySelector(".collection-sort__placeholder");

      // extra action btns
      this.applyBtn = this.querySelector(".applyFilters");
      this.removeBtns = this.querySelectorAll(".removeFilter");
  
      this.init();
      }

    init() {
      this.categoryLabels.forEach((label) => {
        label.addEventListener("click", this.onCategoryClick.bind(this, label));
      });
      this.categoryValueLabels.forEach((label) => {
        label.addEventListener("click", this.showApplyFilter.bind(this));
      });

      if(this.applyBtn) this.applyBtn.addEventListener("click", this.applyFilters.bind(this));
      this.removeBtns.forEach((btn) => {
        btn.addEventListener("click", this.applyFilters.bind(this, btn.dataset.activeFilter));
      });

      if(this.sortDropdown) {
        this.sortDropdown.addEventListener("click", this.sortDropdownClick.bind(this));
        document.querySelector("body").addEventListener("click", (event) => this.sortDropdownClose(event));
      }
    }

    onCategoryClick(currentLabel) {
      // close the currently active category unless the clicked one is the same as the active one
      const activeLabel = this.categoryLabels.find((label) => label.classList.contains("filteropened"));
      if(activeLabel && activeLabel !== currentLabel) activeLabel.classList.remove("filteropened");

      // toggle the filteropened class from the clicked label, regardless of the active status
      currentLabel.classList.toggle("filteropened");

      // show the values corresponding to the current category chosen
      const currentCategory = currentLabel.dataset.category;
      const currentValue = this.categoryValues.find((value) => value.classList.contains("filteractive"));
      const valueToShow = this.categoryValues.find((value) => {
        if(value.dataset.category === currentCategory) return value;
      });

      if(currentValue && currentValue !== valueToShow) currentValue.classList.remove("filteractive");
      valueToShow.classList.add("filteractive");

      // toggle the values container regardless of the active status
      if(!currentLabel.classList.contains("filteropened")) this.valuesContainer.classList.remove("filteropened");
      else this.valuesContainer.classList.add("filteropened");
    }

    showApplyFilter() {
      const availFilters = this.valuesList.filter(radio => radio.checked);
      if(availFilters.length > 0) this.applyBtn.classList.add("apply");
    }

    applyFilters(tagToRemove = "") {
      const filterTagsforUrl =
        this.valuesList.filter(radio => {
          if(radio.checked && radio.value !== tagToRemove) return radio;
        })
        .map(radio => radio.value).join("+");

      window.location.href = `${this.dataset.collectionUrl}/${filterTagsforUrl}`;
    }

    sortDropdownClick() {
      this.sortDropdown.classList.toggle("open");
    }
    sortDropdownClose(event) {
      const eventPath = event.path || event.composedPath();
      if(!eventPath.includes(this.sortDropdown)) {
        this.sortDropdown.classList.remove("open");
      }
    }
  });
}

class MobileCollectionFilter extends HTMLElement {
  constructor() {
    super();

    this.mobileFilter = this.querySelector(".collection-filters--mobile");

    this.querySelectorAll(
      "[aria-controls=collection-filters--mobile], .mobile-filter-drawer__close"
    ).forEach((button) =>
      button.addEventListener("click", this.toggleMobileFilter.bind(this))
    );

    this.querySelector("#apply-mobile-filter__button").addEventListener(
      "click",
      this.applyMobileFilter.bind(this)
    );
  }

  getSortFilter() {
    const urlSearchParams = new URLSearchParams(location.search);

    if(!urlSearchParams.get("sort_by")) {
      return;
    }

    return `?sort_by=${urlSearchParams.get("sort_by")}`;
  }

  toggleMobileFilter(e) {
    this.mobileFilter.classList.toggle("open");
  }

  applyMobileFilter(tagToRemove = "") {
    const filterTagsforUrl = Array.from(
      this.querySelectorAll("accordion-filter input")
    )
      .filter((radio) => {
        if (radio.checked && radio.value !== tagToRemove) return radio;
      })
      .map((radio) => radio.value)
      .join("+");

    const sortStr = this.getSortFilter() || "";

    window.location.href = `${this.dataset.collectionUrl}/${filterTagsforUrl}${sortStr}`;
  }
}

customElements.define("mobile-collection-filter", MobileCollectionFilter);


class AccordionFilter extends HTMLElement {
 constructor() {
    super();
    this.accordionHeader = this.querySelector("button[aria-controls]");
    this.accordionPanel = this.querySelector(".accordion-panel");

    this.accordionHeader.addEventListener('click', this.toggleAccordion.bind(this))
 }

 toggleAccordion(e){
  const isOpen = this.accordionHeader.getAttribute("aria-expanded");

  if(isOpen === 'false'){
    this.accordionHeader.setAttribute("aria-expanded", true);
    this.accordionPanel.setAttribute("aria-hidden", false)
    return;
  }

  this.accordionHeader.setAttribute("aria-expanded", false);
  this.accordionPanel.setAttribute("aria-hidden", true);
 }
}

customElements.define("accordion-filter", AccordionFilter);
